// App
import React, { useEffect, useRef } from 'react';

// Components
import Button from 'app/shared/core/Button';

// Misc / utils
import IconX from 'images/icons/x-white.svg';
import * as S from 'app/shared/modules/hdp/ListingHiddenNotification/styles';

type ListingHiddenNotificationProps = {
  onClose?: () => void;
  onUndo?: () => void;
};

const noop = (): void => {
  // default empty handler
};

const ListingHiddenNotification = ({ onClose = noop, onUndo = noop }: ListingHiddenNotificationProps) => {
  // React
  const hiddenNoticeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (e: MouseEvent | TouchEvent) => {
      if (hiddenNoticeRef.current && !hiddenNoticeRef.current.contains(e.target as Node | null)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('touchstart', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('touchstart', handleMouseDown);
    };
  }, [onClose]);

  return (
    <S.ListingHiddenNotice ref={hiddenNoticeRef}>
      <S.ListingHiddenText size="sm">Listing hidden from search results.</S.ListingHiddenText>
      <Button btnType="text-color-light" size="sm" onClick={onUndo}>
        Undo
      </Button>
      <S.ListingHiddenClose onClick={onClose}>
        <img src={IconX} height={20} width={20} alt="" />
      </S.ListingHiddenClose>
    </S.ListingHiddenNotice>
  );
};

export default ListingHiddenNotification;
